import { render, staticRenderFns } from "./ProductSummaryList.vue?vue&type=template&id=06919d28&"
import script from "./ProductSummaryList.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports